import type { ThemeLocaleData } from "../../shared/index.js";

export const idLocale: ThemeLocaleData = {
  lang: "id-ID",

  navbarLocales: {
    langName: "Indonesia",
    selectLangAriaLabel: "Pilih Bahasa",
  },

  metaLocales: {
    author: "Penulis",
    date: "Ditulis pada",
    origin: "Original",
    views: "Dilihat",
    category: "Kategori",
    tag: "Tag",
    readingTime: "Waktu Membaca",
    words: "Kata",
    toc: "Pada Halaman Ini",
    prev: "Sebelumnya",
    next: "Selanjutnya",
    contributors: "Kontributor",
    editLink: "Edit halaman ini",
    print: "Cetak",
  },

  blogLocales: {
    article: "Artikel",
    articleList: "Daftar artikel",
    category: "Kategori",
    tag: "Tag",
    timeline: "Linimasa",
    timelineTitle: "Kemarin adalah kenangan, esok adalah harapan",
    all: "Semua",
    intro: "Perkenalan",
    star: "Berbintang",
    empty: "$text kosong",
  },

  paginationLocales: {
    prev: "Sebelumnya",
    next: "Selanjutnya",
    navigate: "Ke Halaman",
    action: "Pergi",
    errorText: "Tolong masukkan angka antara 1 dan $page !",
  },

  outlookLocales: {
    themeColor: "Warna Tema",
    darkmode: "Mode Tema",
    fullscreen: "Layar Penuh",
  },

  encryptLocales: {
    iconLabel: "Halaman terkunci",
    placeholder: "Masukkan kata sandi",
    remember: "Ingat kata sandi",
    errorHint: "Mohon masukkan kata sandi yang benar!",
  },

  routerLocales: {
    skipToContent: "Langsung ke konten utama",
    notFoundTitle: "Halaman tidak ditemukan",
    notFoundMsg: [
      "Tidak ada apapun disini.",
      "Bagaimana kita bisa sampai kesini?",
      "Itu adalah Empat-Nol-Empat.",
      "Tampaknya kami memiliki beberapa tautan situs yang rusak.",
    ],
    back: "Kembali",
    home: "Ke Beranda",
  },
};
